import { IAvailableAppointment, IMainAppointment, Reminder } from "../Models";
import { baseUrl, getTokenFromLocalStorage } from "./Configuration";
import { AddReminder } from "./ReminderService";
import { v4 as uuidv4 } from "uuid";

function convertToString(dateTime: Date | null) {
  if (dateTime === null) return "";
  const hoursDiff = dateTime.getHours() - dateTime.getTimezoneOffset() / 60;
  const minsDiff = dateTime.getMinutes() - (dateTime.getTimezoneOffset() % 60);
  dateTime.setHours(hoursDiff, minsDiff);
  return dateTime.toISOString();
}

export async function saveAppointments(appointments: IAvailableAppointment[]) {
  const url = baseUrl + "/api/Showings/SaveAvailableAppointmentsForListing";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  const requestBody = {
    appointments: appointments.map((a) => ({
      id: a.id,
      listingID: a.listingID,
      startTime: convertToString(a.startTime),
      endTime: convertToString(a.endTime),
      capacity: a.capacity,
      groupId: a.groupId,
    })),
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to save appointments");
    }
    var reminders: Reminder[] = [];
    for (var apt of appointments) {
      for (var r of apt.reminders) {
        if (
          r.availableAppointmentId.length === 0 &&
          apt.id.length > 0 &&
          r.reminder > 0
        ) {
          reminders.push({
            id: r.id === "" ? "00000000-0000-0000-0000-000000000000" : r.id,
            availableAppointmentId: apt.id,
            reminder: r.reminder,
            reminderType: r.reminderType,
          });
        }
      }
    }
    reminders.length > 0 && (await AddReminder(reminders));

    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function fetchAppointmentsPerListingData(listingID: string) {
  try {
    const response = await fetch(
      baseUrl + "/api/Showings/GetAvailableAppointmentsForListing/" + listingID,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error); // Add this line for debugging
    throw error;
  }
}

export async function fetchPublicAppointmentsPerListingData(listingID: string) {
  try {
    const response = await fetch(
      baseUrl + "/api/Showings/GetAvailableAppointmentsForListing/" + listingID,
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error); // Add this line for debugging
    throw error;
  }
}

export async function fetchConfirmedAppointments() {
  try {
    const response = await fetch(
      baseUrl + "/api/Showings/GetConfirmedAppointments",
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error); // Add this line for debugging
    throw error;
  }
}

export async function CancelAppointments(
  appointmentId: string[],
  all: Boolean,
) {
  try {
    const response = await fetch(baseUrl + `/api/Appointments/cancel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
      },
      body: JSON.stringify({
        appointmentIds: appointmentId,
        all: all,
      }),
    });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  } catch (error) {
    console.log(error); // Add this line for debugging
    throw error;
  }
}

export async function DeleteAppointmentSlot(id: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Appointments/DeleteAppointmentSlot/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  } catch (error) {
    console.log(error); // Add this line for debugging
    throw error;
  }
}

export async function fetchAvailalbeAppointmentsForAutomaticResponseById(
  AutoResponseId: string,
) {
  try {
    const response = await fetch(
      baseUrl +
        "/api/Showings/GetAvailableAppointmentsForAutomaticResponseID/" +
        AutoResponseId,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function fetchAppointmentWithTenant(groupId: string) {
  try {
    if (!groupId) {
      return [];
    }
    const response = await fetch(
      `${baseUrl}/api/Appointments/GetAppointmentWithTenant/${groupId}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function RejectConfirmAppointment(
  arhIds: string[],
  IsRejected: Boolean,
) {
  try {
    const response = await fetch(
      baseUrl + `/api/Appointments/RejectConfirmAppointment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
        body: JSON.stringify({
          arhIds,
          IsRejected,
        }),
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  } catch {
    throw new Error("Error cancelling confirm appointment");
  }
}

export async function getAvailableAppointmentById(id: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Appointments/availableAppointment/${id}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch {
    throw new Error("Error cancelling confirm appointment");
  }
}
export async function rescheduleAppointment(data: any) {
  const url = baseUrl + "/api/Appointments/RescheduleAppointment";
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "PUT", // Fix: Use PUT instead of POST
      headers: headers,
      body: JSON.stringify(data),
    });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      const errorText = await response.text(); // Read error response for debugging
      throw new Error(`Failed to reschedule: ${errorText}`);
    }

    return response;
  } catch (error: any) {
    console.error("Error rescheduling appointment:", error);
    throw new Error(`Error: ${error.message}`);
  }
}

export async function ResendTenants(data: any) {
  const url = baseUrl + "/api/Appointments/confirmResend";
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "PUT", // Fix: Use PUT instead of POST
      headers: headers,
      body: JSON.stringify(data),
    });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      const errorText = await response.text(); // Read error response for debugging
      throw new Error(`Failed to confirm resend: ${errorText}`);
    }

    return response;
  } catch (error: any) {
    console.error("Error saving resending tenant:", error);
    throw new Error(`Error: ${error.message}`);
  }
}

export async function getMainAppointment(groupId: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Appointments/MainAppointment/${groupId}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch {
    throw new Error("Error cancelling confirm appointment");
  }
}

export async function saveMainAppointment(mainAppointment: IMainAppointment) {
  try {
    const requestBody = {
      id: mainAppointment.id,
      listingId: mainAppointment.listingId,
      openingTime: convertToString(mainAppointment.openingTime),
      closingTime: convertToString(mainAppointment.closingTime),
      openHoursBefore: mainAppointment.openHoursBefore,
      openHoursAfter: mainAppointment.openHoursAfter,
      rosterTime: mainAppointment.rosterTime,
      resendCancelled: mainAppointment.resendCancelled,
      resendUnconfirmed: mainAppointment.resendUnconfirmed,
    };

    const response = await fetch(
      baseUrl + `/api/Appointments/SaveMainAppointment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
        body: JSON.stringify(requestBody),
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch {
    throw new Error("Error Save Mainappoinment");
  } finally {
    console.log("err");
  }
}

export async function generateAppointmentsAndUpdateState(
  listingID: string,
  startDateTime: Date | null,
  endDateTime: Date | null,
  slotDurationMinutes: number,
  capacity: number,
  reminders: Reminder[],
  groupId: string,
): Promise<void> {
  const generatedAppointments = [];

  try {
    let currentDateTime = new Date(
      startDateTime ? new Date(startDateTime) : new Date(),
    );

    if (endDateTime) {
      if (slotDurationMinutes > 0) {
        while (currentDateTime < endDateTime) {
          const appointmentEndTime = new Date(currentDateTime);
          appointmentEndTime.setMinutes(
            appointmentEndTime.getMinutes() + slotDurationMinutes,
          );

          if (appointmentEndTime > endDateTime) {
            appointmentEndTime.setTime(endDateTime.getTime());
          }

          // Create an appointment object
          const appointment = {
            id: uuidv4(),
            listingID: listingID,
            startTime: new Date(currentDateTime),
            endTime: appointmentEndTime,
            capacity: capacity,
            slotOrder: 0,
            reminders: reminders,
            groupId: groupId,
          };
          generatedAppointments.push(appointment);
          currentDateTime = appointmentEndTime;
        }
      } else {
        // Create an appointment object
        const appointment = {
          id: uuidv4(),
          listingID: listingID,
          startTime: new Date(currentDateTime),
          endTime: new Date(endDateTime),
          capacity: capacity,
          slotOrder: 0,
          reminders: reminders,
          groupId: groupId,
        };
        generatedAppointments.push(appointment);
      }

      await saveAppointments(generatedAppointments);
    }
  } catch (error) {
    console.log("Error in generateAppointmentsAndUpdateState", error);
    throw error; // Ensure the error is propagated
  } finally {
    await resendemail(groupId, listingID);
  }
}

export async function resendemail(groupId: string, listingId: string) {
  try {
    const response = await fetch(
      `${baseUrl}/api/Appointments/ResendAppointmentInternal?groupId=${groupId}&listingId=${listingId}`,
      {
        method: "GET", // assuming it's a POST; change to GET if the API expects it
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
          "Content-Type": "application/json",
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`Failed to resend email: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error resending appointment email:", error);
    throw error;
  }
}

export const getEasternCurrentTime = () => {
  const now = new Date();
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const parts = formatter.formatToParts(now);

  // Extract parts into numbers
  const getPart = (type: string) =>
    Number(parts.find((p) => p.type === type)?.value);

  const year = getPart("year");
  const month = getPart("month") - 1; // Month is 0-based in JS Date
  const day = getPart("day");
  const hour = getPart("hour");
  const minute = getPart("minute");
  const second = getPart("second");

  return new Date(year, month, day, hour, minute, second);
};

export async function getTenantContactsByListing(listingId: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Appointments/TenantContacts/Listing/${listingId}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function fetchSlotConfirmationSummaryByListing(listingId: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Appointments/GetSlotConfirmationSummary/${listingId}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
}
